import { EnterFullScreenIcon, ExitFullScreenIcon } from '@radix-ui/react-icons';
import { IconButton } from '@radix-ui/themes';
import { useMediaRemote, useMediaState } from '@vidstack/react';
import { useTranslation } from 'react-i18next';

export const SmartPlayerFullscreen = () => {
    const { t } = useTranslation('smartPlayer');
    const isFullscreen = useMediaState('fullscreen');
    const remote = useMediaRemote();

    return (
        <IconButton
            size='2'
            variant='ghost'
            color='gray'
            highContrast
            onClick={() => remote.toggleFullscreen()}
            title={
                isFullscreen
                    ? t('controls.exit_fullscreen')
                    : t('controls.enter_fullscreen')
            }
        >
            {isFullscreen ? (
                <ExitFullScreenIcon width='18' height='18' />
            ) : (
                <EnterFullScreenIcon width='18' height='18' />
            )}
        </IconButton>
    );
};
